import { useSigma } from '@react-sigma/core';
import { useEffect } from 'react';

type CameraControllerProps = {
  targetNodeId: string | null;
};

export const CameraController = ({ targetNodeId }: CameraControllerProps) => {
  const sigma = useSigma();

  useEffect(() => {
    if (!targetNodeId) return;
    const nodeDisplayData = sigma.getNodeDisplayData(targetNodeId);
    if (!nodeDisplayData) return;
    sigma
      .getCamera()
      .animate({ x: nodeDisplayData.x, y: nodeDisplayData.y, ratio: 0.05 }, { duration: 600 });
  }, [targetNodeId, sigma]);

  return null;
};
